import React, { FunctionComponent } from 'react';
import {
  SelectInput as RaSelectInput,
  AutocompleteInput as RaAutocompleteInput,
} from 'react-admin';
import { CountryInputProps } from './types';
import countries from '../../constants/countries';

const CountryInput: FunctionComponent<CountryInputProps> = (props) => {
  const { source, children, ...restProps } = props;

  return (
    <RaAutocompleteInput source={source} choices={countries} {...restProps} />
  );
};

export default CountryInput;
